// extracted by mini-css-extract-plugin
export default {"container":"filter_authorization_action_container__y0V8I","value_text":"filter_authorization_action_value_text__qvn5C"};